/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ContentManagementGetTokenResponse } from './ContentManagementGetTokenResponse';

export type ContentManagementGetTokenResponseApiRespoonse = {
    data?: ContentManagementGetTokenResponse;
    status?: ContentManagementGetTokenResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace ContentManagementGetTokenResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

